import { MARQUEE } from "../lib/site";

export default function Marquee() {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <section data-testid="editorial-marquee" className="bg-[#18181B] py-8 overflow-hidden border-y border-[#FAF7F2]/10">
      <div className="pp-marquee-track">
        {items.map((word, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="font-display italic text-4xl md:text-6xl text-[#FAF7F2]/85 px-8">{word}</span>
            <span className="text-[#C5A059] text-2xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
